import * as ol from './ol';
import * as maplibre from './maplibre';

export * as ol from './ol';
export * as maplibre from './maplibre';

export default {
  ol,
  maplibre,
};
